import { forwardRef, useEffect } from "react";
import { Mui, usePrevious} from "@osu/react-ui";

const alertStyles = (theme, severity) => {
  const colors = theme.palette[severity]
  return {
    [`&:focus`]: {
      outline: `${colors.light ?? '-webkit-focus-ring-color'} double 4px`
    }
  }
}

const Alert = forwardRef(({ severity, description, className }, ref) => {
  const previousSeverity = usePrevious(severity)
  const previousDescription = usePrevious(description)
  
  let alertProps = {
    role: 'alert',
  }
  if(severity && description) {
    alertProps = {
      component: Mui.Alert,
      severity,
      className: className || 'margin-bottom-2',
      variant: 'outlined',
      sx: (theme) => alertStyles(theme, severity)
    }
  }

  useEffect(() => {
    const updateHappenedToDescription = !previousDescription && !!alertProps.component
    const changeInSeverity = alertProps.severity && (previousSeverity !== alertProps.severity)
    if(ref?.current && (updateHappenedToDescription || changeInSeverity)) {
      ref.current.focus()
    }
  }, [alertProps.component, alertProps.severity, previousDescription, previousSeverity, ref])

  return (
    <Mui.Box ref={ref} {...alertProps} tabIndex="-1">
      {description}
    </Mui.Box>
  );
})

export default Alert;
